define('v3/Pages/Check/ViewModels/CheckOverview.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Services/pageStateService',
	'v3/Pages/Check/Services/Check.Service',
	'v3/Common/Services/urlService',
	'v3/Common/Models/enums',
	'env'
], function (ko, _, pageStateService, checkService, urlService, enums, env) {
	function CheckOverviewViewModel () {
		var self = this;

		var goToReview = function () {
			window.location.href = urlService.reviewPageUrl();
		};

		self.showSchoolReport = env.userInfo.isChangeClassAvailable;

		self.navBackButtonParams = {
			name: Strings.BackToOverview,
			linkFunction: goToReview
		};

		self.enums = enums;
		self.env = env;
		self.isLoading = ko.observable(true);

		self.className = env.userInfo.className;
		self.noSubjectsAvailable = ko.observable(false);
		self.selectedSubjectGroupId = ko.observable();
		self.selectedSubjectGroupItem = ko.observable();
		self.selectedPeriod = ko.observable(enums.semesterPeriod.year);
		self.selectedPupilId = ko.observable();
		self.selectedPupilName = ko.observable();
		self.activeView = pageStateService.getStringObservable('activeView');

		self.isPdfSelection = ko.observable(pageStateService.getBoolObservable('forcePrint')());
		if (self.isPdfSelection()) {
			pageStateService.removeKey('forcePrint');
		}

		checkService.getSubjectGroupsByEducationPlanAvailability().done(function (data) {
			if (data.length === 0) {
				self.activeView('empty');
				return;
			}

			var savedPageState = checkService.getPageStateView();
			if (!self.activeView() && savedPageState) {
				self.activeView(savedPageState);
			}

			if (self.activeView() !== enums.checkViewMode.Pupil) {
				self.activeView(enums.checkViewMode.Class);
			}
		});

		self.activateClassView = function () {
			if (self.activeView() !== enums.checkViewMode.Class) {
				checkService.setPageState(enums.checkViewMode.Class);
				self.activeView(enums.checkViewMode.Class);
				self.isPdfSelection(false);
			}
		};
		self.activatePupilView = function () {
			if (self.activeView() !== enums.checkViewMode.Pupil) {
				self.activeView(enums.checkViewMode.Pupil);

				if (self.selectedPupilId()) {
					checkService.setPageState(enums.checkViewMode.Pupil, self.selectedPupilId());
				} else {
					checkService.setPageState(enums.checkViewMode.Pupil);
				}
			}
		};

		self.goToTeach = function () {
			checkService.goToTeach();
		};

		self.showPdfSelection = function () {
			self.isPdfSelection(!self.isPdfSelection());
		};
	}

	return CheckOverviewViewModel;
});

